import { HistoricoFrota } from "components/ModalHistoricoViagensFrota/ModalHistoricoViagensFrota.tsx";
import { Motorista } from "../../models/Motorista.ts";
import { api } from "./UrlPadrao.js";

interface DisponibilidadeFrotaParams {
	token: string;
	dias: number;
	eixos: number;
	status: number;
	data: string;
	tipoCarroceriaId: number;
	contexto: string;
	elegivelBrf: number;
}

interface MotoristaParams {
	token: string | undefined;
	id: number;
}

interface MotoristaParams {
	token: string | undefined;
	id: number;
}

export const getDisponibilidadeFrota = async ({
	token,
	dias,
	eixos,
	status,
	data,
	tipoCarroceriaId,
	elegivelBrf,
	contexto,
}: DisponibilidadeFrotaParams): Promise<Motorista[]> => {
	const response = await api.get(
		`veiculo/disponibilidade-frota/${dias}/${eixos}/${status}/${data}/${tipoCarroceriaId}/${elegivelBrf}/${contexto}`,
		{
			headers: {
				Authorization: token,
			},
		},
	);
	return response.data;
};

export const getHistoricoViagens = async ({
	token,
	id,
}: MotoristaParams): Promise<HistoricoFrota[]> => {
	const response = await api.get(`motorista/ultimas-viagens/${id}`, {
		headers: {
			Authorization: token ?? "",
		},
	});
	return response.data;
};
